<div class="nova__dialog__toolbar">
  <div class="nova__dialog__toolbar__title">
    PDF Viewer
  </div>
  <div class="nova__dialog__toolbar__controls">
    <button class="nova__button--icon" mat-dialog-close><mat-icon
    class="nova-toolbar__controls__icon--close">close</mat-icon></button>
  </div>
</div>
<div mat-dialog-content class="nova__dialog__content">
  <div class="nova-document-viewer">
    <nova-document-viewer #docViewer class="document-viewer" [page]="data?.pageNumber" height="100%"
      [sidebarVisible]="false" [showToolbar]="false" [pageViewMode]="'single'"
    [document$]="data?.document$"></nova-document-viewer>
  </div>

  @if (textRequirements.length) {
    <nova-doc-type-text-reqs
    [requirements]="textRequirements"></nova-doc-type-text-reqs>
  }
</div>